<template>
  <header id="header" v-if="profile" :class="{ 'header--scrolled': scrolled }">
    <div class="header__inner">

      <div v-if="isMobileHeader" class="header__mobile-actions">
        <a
          class="header__mobile-icon-btn"
          href="https://api.whatsapp.com/send/?phone=972535002558&text&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>
        </a>

        <button
          v-if="!user_data"
          type="button"
          class="header__mobile-icon-btn"
          aria-label="התחברות"
          @click="$emit('show_login')"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
        </button>

        <router-link v-if="user_data" class="header__mobile-icon-btn" to="/user" aria-label="חשבון">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
        </router-link>
      </div>

      <!-- Mobile: live link -->
      <li v-if="isMobileHeader" class="header__live-mobile" style="list-style-type: none;">
        <router-link to="/live">שידור חי</router-link>
      </li>

      <!-- Logo -->
      <router-link to="/" id="logo" aria-label="דף הבית של Tov"></router-link>

      <!-- Desktop nav -->
      <nav id="menu" aria-label="ניווט ראשי" v-if="!isMobileHeader">
        <ul>
          <li class="dropdownW3">
            <router-link to="/categories/1">קטגוריות</router-link>
            <div class="dropdown-contentW3">
              <div
                v-for="item in menu.slice(0, 5)"
                class="active"
                :key="'menu' + item.link"
              >
                <router-link :to="'/' + item.link + '/type/1'">{{ item.name }}</router-link>
              </div>
              <div class="active">
                <router-link to="/categories/1">לקטגוריות נוספות</router-link>
              </div>
            </div>
          </li>
          <li class="dropdownW3">
            <router-link to="/categories/2">סדרות</router-link>
          </li>
          <li class="dropdownW3">
            <router-link to="/categories/1">אקדמיית TovTv</router-link>
            <div class="dropdown-contentW3">
              <div
                v-for="item in menu.slice(0, 5)"
                class="active"
                :key="'academy-menu' + item.link"
              >
                <router-link :to="'/' + item.link + '/type/1'">{{ item.name }}</router-link>
              </div>
              <div class="active">
                <router-link to="/categories/1">לעוד באקדמיית TovTv</router-link>
              </div>
            </div>
          </li>
          <li v-if="user_data && hasPersonalization">
            <router-link to="/favorites">המועדפים שלי</router-link>
          </li>
          <li v-if="live.id > 0" class="btn_live">
            <router-link to="/live">שידור חי כנס Tov הגדול</router-link>
          </li>
        </ul>
      </nav>

      <!-- Desktop: action area -->
      <div id="header-actions" v-if="!isMobileHeader">
        <ul>
          <!-- WhatsApp -->
          <li>
            <a
              href="https://api.whatsapp.com/send/?phone=972535002558&text&type=phone_number&app_absent=0"
              class="header__wts-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <img src="@/assets/whatsapp-new.svg" alt="WhatsApp" width="26" height="26" />
            </a>
          </li>

          <!-- Search -->
          <li>
            <UiIconButton
              variant="ghost"
              size="md"
              aria-label="חיפוש"
              @click="open_search()"
            >
              <!-- search SVG icon -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            </UiIconButton>
          </li>

          <!-- Signup CTA (logged-out only) -->
          <li v-if="!user_data">
            <UiButton variant="primary" size="md" @click="openSignup()">להצטרפות</UiButton>
          </li>

          <!-- Login / User menu -->
          <li
            class="header__user-item"
            @mouseenter="openUserMenu"
            @mouseleave="closeUserMenu"
          >
            <!-- Logged out: login trigger -->
            <button
              v-if="!user_data"
              type="button"
              class="header__login-btn"
              @click="$emit('show_login')"
            >
              <!-- user SVG icon -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="header__user-icon" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <span>התחברות</span>
            </button>

            <!-- Logged in: user menu trigger -->
            <button
              v-if="user_data"
              type="button"
              class="header__login-btn"
              :aria-expanded="show_user_menu ? 'true' : 'false'"
              aria-controls="user_menu"
              @click="show_user_menu = !show_user_menu"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="header__user-icon" aria-hidden="true"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <span>{{ user_data.display_name }}</span>
            </button>

            <div
              id="user_menu"
              role="menu"
              v-show="show_user_menu"
              @mouseenter="openUserMenu"
              @mouseleave="closeUserMenu"
              v-on-clickaway="away"
            >
              <ul>
                <li role="none"><router-link to="/contact" role="menuitem">צור קשר</router-link></li>
                <li role="none"><router-link to="/user" role="menuitem">חשבון</router-link></li>
                <li role="none">
                  <button type="button" role="menuitem" class="user-menu__logout" @click="logout()">יציאה מ +Tov</button>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>

    </div>
  </header>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import UiButton from '@/components/ui/Button.vue';
import UiIconButton from '@/components/ui/IconButton.vue';

export default {
  components: { UiButton, UiIconButton },
  mixins: [clickaway],

  props: ['user_data', 'menu', 'profile', 'live'],

  data() {
    return {
      show_user_menu: false,
      userMenuCloseTimer: null,
      scrolled: false,
      isMobileHeader: false,
      user_token: localStorage.getItem('user_token'),
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
    };
  },

  computed: {
    heroRoutes() {
      return ['/', '/info'];
    },
    isHeroRoute() {
      const p = this.$route.path;
      return p === '/' || p.startsWith('/info/');
    },
    hasPersonalization() {
      if (!this.profile) return false;
      return String(this.profile.has_perms) === '1'
        || String(this.profile.perms_show_alerts) === '1'
        || String(this.profile.perms_auto_skip) === '1';
    },
  },

  watch: {
    $route() {
      this.updateScrolled();
    },
  },

  mounted() {
    this._onScroll = () => { this.updateScrolled(); };
    this._onResize = () => { this.updateMobileHeader(); };
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    this.updateScrolled();
    this.updateMobileHeader();

    if (this.$route.query['utm_source']) {
      this.utm_source = this.$route.query['utm_source'];
    } else if (localStorage.getItem('utm_source')) {
      this.utm_source = localStorage.getItem('utm_source');
    }

    if (this.$route.query['utm_medium']) {
      this.utm_medium = this.$route.query['utm_medium'];
    } else if (localStorage.getItem('utm_medium')) {
      this.utm_medium = localStorage.getItem('utm_medium');
    }

    if (this.$route.query['utm_campaign']) {
      this.utm_campaign = this.$route.query['utm_campaign'];
    } else if (localStorage.getItem('utm_campaign')) {
      this.utm_campaign = localStorage.getItem('utm_campaign');
    }
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onResize);
    if (this.userMenuCloseTimer) {
      clearTimeout(this.userMenuCloseTimer);
      this.userMenuCloseTimer = null;
    }
  },

  methods: {
    updateMobileHeader() {
      if (typeof window === 'undefined') return;
      this.isMobileHeader = window.innerWidth <= 900;
    },

    updateScrolled() {
      if (!this.isHeroRoute) {
        this.scrolled = true;
        return;
      }
      this.scrolled = window.scrollY > 10;
    },

    open_search() {
      this.$emit('open_search', true);
    },

    logout() {
      localStorage.removeItem('user_token');
      localStorage.removeItem('user_restrictions');
      Object.keys(localStorage)
        .filter(k => k.startsWith('preview_used_') || k.startsWith('article_credit_'))
        .forEach(k => localStorage.removeItem(k));
      document.location = '/';
    },

    away() {
      if (this.userMenuCloseTimer) {
        clearTimeout(this.userMenuCloseTimer);
        this.userMenuCloseTimer = null;
      }
      this.show_user_menu = false;
    },

    openUserMenu() {
      if (this.user_data) {
        if (this.userMenuCloseTimer) {
          clearTimeout(this.userMenuCloseTimer);
          this.userMenuCloseTimer = null;
        }
        this.show_user_menu = true;
      }
    },

    closeUserMenu() {
      if (this.user_data) {
        if (this.userMenuCloseTimer) {
          clearTimeout(this.userMenuCloseTimer);
        }
        this.userMenuCloseTimer = setTimeout(() => {
          this.show_user_menu = false;
          this.userMenuCloseTimer = null;
        }, 180);
      }
    },

    openSignup() {
      this.$store.commit('open_signup', { step: 1, plan_id: 0 });
    },
  },
};
</script>

<style scoped lang="scss">
/* ── Shell ── */
#header {
  position: fixed;
  inset-block-start: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  height: 68px;
  background: transparent;
  box-shadow: none;
  color: var(--color-text);
  z-index: 999;
  transition: background 200ms ease, box-shadow 200ms ease;
}

#header.header--scrolled {
  background: var(--color-surface1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.header__inner {
  height: 100%;
  display: flex;
  align-items: center;
  padding-inline: 36px;
  position: relative;
}

/* ── Logo ── */
#logo {
  display: block;
  width: 120px;
  height: 100%;
  background: url(../assets/logo.png) no-repeat;
  background-size: contain;
  background-position: center center;
  position: absolute;
  inset-inline-start: 20px;
  inset-block-start: 0;
}

@media (min-width: 901px) {
  .header__inner {
    padding-inline-start: 190px;
    padding-inline-end: 280px;
  }
}
@media (max-width: 900px) {
  #header {
    height: 60px;
  }

  .header__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;
    gap: 8px;
  }

  .header__inner::before {
    content: '';
    display: block;
    width: 76px;
    flex: 0 0 76px;
    order: 1;
  }

  #header #logo {
    position: static;
    width: 96px;
    height: 34px;
    flex: 0 0 96px;
    order: 2;
    margin: 0;
    align-self: center;
  }

  .header__mobile-actions {
    order: 3;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    position: relative;
    z-index: 2;
  }

  .header__mobile-actions .header__mobile-icon-btn {
    width: 36px;
    min-width: 36px;
    height: 36px;
    min-height: 36px;
    padding: 6px;
  }
}

/* ── Desktop nav ── */
#menu {
  flex: 1;
}

#menu ul {
  list-style: none;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

#menu li {
  position: relative;
}

#menu li a {
  display: block;
  line-height: 68px;
  color: var(--color-textMuted);
  padding-inline: var(--space-6);
  font-size: var(--text-base); /* 14px */
  font-weight: 600; /* always semibold — prevents layout shift on active */
  text-decoration: none;
  transition: color var(--duration-fast) var(--easing-default),
              border-color var(--duration-fast) var(--easing-default);
  border-bottom: 2px solid transparent;
  box-sizing: border-box;
}

#menu li a:hover {
  color: var(--color-text);
}

#menu li a.router-link-active {
  color: var(--color-text);
  border-bottom-color: var(--color-text);
}

/* Live badge nav item */
#menu .btn_live a {
  line-height: 34px !important;
  padding-inline: var(--space-6);
  background: var(--color-accent);
  color: #fff;
  height: 40px;
  margin-block: 14px;
  border-radius: var(--radius-sm);
  display: block;
  transition: opacity var(--duration-fast) var(--easing-default);
}

#menu .btn_live a:hover {
  opacity: 0.85;
}

/* Dropdown */
.dropdownW3 .dropdown-contentW3 {
  display: none;
  position: absolute;
  inset-block-start: 68px;
  inset-inline-start: 0;
  background: var(--color-surface1);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  min-width: 160px;
  z-index: 100;
  padding: var(--space-2) 0;
}

.dropdownW3:hover .dropdown-contentW3,
.dropdownW3:focus-within .dropdown-contentW3 {
  display: block;
}

.dropdownW3 .dropdown-contentW3 a {
  display: block;
  padding: var(--space-2) var(--space-4);
  color: var(--color-textMuted);
  font-size: var(--text-base);
  line-height: var(--leading-relaxed);
  text-decoration: none;
  transition: background var(--duration-fast) var(--easing-default),
              color var(--duration-fast) var(--easing-default);
}

.dropdownW3 .dropdown-contentW3 a:hover {
  background: var(--color-surface3);
  color: var(--color-text);
}

/* ── Desktop action area ── */
#header-actions {
  position: absolute;
  inset-inline-end: 40px;
  inset-block-start: 0;
  inset-block-end: 0;
  display: flex;
  align-items: center;
}

#header-actions > ul {
  list-style: none;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  gap: var(--space-2);
  flex-direction: row-reverse; 
}

#header-actions ul li {
  position: relative;
}

/* WhatsApp link */
.header__wts-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-2);
  border-radius: var(--radius-sm);
  transition: background var(--duration-fast) var(--easing-default);
}

.header__wts-link:hover {
  background: rgba(255, 255, 255, 0.08);
}

.header__wts-link:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

/* Login / user name button */
.header__login-btn {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  background: transparent;
  border: none;
  color: var(--color-text);
  font-size: var(--text-base);
  font-family: var(--font-hebrew);
  cursor: pointer;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-sm);
  min-height: 44px;
  white-space: nowrap;
  transition: background var(--duration-fast) var(--easing-default);
}

.header__login-btn span {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header__login-btn:hover {
  background: rgba(255, 255, 255, 0.08);
}

.header__login-btn:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.header__user-icon {
  flex-shrink: 0;
}

/* User dropdown menu */
#user_menu {
  position: absolute;
  inset-inline-start: 0px;
  inset-block-start: calc(68px - 8px); /* snap to bottom of header */
  background: var(--color-surface1);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--space-3);
  width: 200px;
  box-shadow: var(--shadow-md);
  z-index: 200;
}

#user_menu ul {
  list-style: none;
  padding: 0;
  margin: 0;

}

#user_menu ul li {
  min-height: 44px;
  line-height: 44px;
  margin-block-end: var(--space-1);
  display: block;
  overflow: hidden;
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: background var(--duration-fast) var(--easing-default);
}

#user_menu ul li:hover {
  background: var(--color-surface3);
}

#user_menu ul li a,
.user-menu__logout {
  display: block;
  padding-inline: var(--space-2);
  color: var(--color-text);
  font-size: var(--text-base);
  font-family: var(--font-hebrew);
  text-decoration: none;
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: start;
}

/* ── Mobile elements ── */
.header__mobile-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  min-width: 44px;
  min-height: 44px;
  border-radius: var(--radius-sm);
  color: var(--color-text);
  padding: var(--space-2);
  transition: background var(--duration-fast) var(--easing-default);
}

.header__mobile-icon-btn:hover {
  background: rgba(255, 255, 255, 0.08);
}

.header__mobile-icon-btn:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.header__live-mobile {
  padding-block-start: 14px;
  display:none;
}

.header__live-mobile a {
  padding-inline: 5px;
  color: var(--color-text);
  text-decoration: none;
  font-size: var(--text-base);
}

/* ── User item container for dropdown positioning ── */
.header__user-item {
  position: relative;
}

/* ── Reduced motion ── */
@media (prefers-reduced-motion: reduce) {
  #header,
  #header.header--scrolled,
  #menu li a,
  .header__login-btn,
  .header__wts-link,
  #user_menu ul li {
    transition: none;
  }
}
</style>
